import React from "react";
import {
	DateInput,
	ReferenceInput,
	SearchInput,
	TextInput,
	useTranslate,
} from "react-admin";
import { Filter, SelectInput } from "react-admin";

const ModerationActivitiesFilter = (props) => {
	const translate = useTranslate();

	return (
		<Filter {...props}>
			<SearchInput source="query" alwaysOn variant={"outlined"} />

			<SelectInput
				sx={{ marginBottom: "0" }}
				source="previous_status"
				resettable
				choices={[
					{
						id: 0,
						name: translate("resources.comments.status.accepted"),
					},
					{
						id: 2,
						name: translate("resources.comments.status.rejected"),
					},
					{
						id: 1,
						name: translate("resources.comments.status.pending"),
					},
				]}
				alwaysOn
			/>

			<SelectInput
				sx={{ marginBottom: "0" }}
				source="new_status"
				resettable
				choices={[
					{
						id: 0,
						name: translate("resources.comments.status.accepted"),
					},
					{
						id: 2,
						name: translate("resources.comments.status.rejected"),
					},
					{
						id: 1,
						name: translate("resources.comments.status.pending"),
					},
				]}
				alwaysOn
			/>

			<DateInput
				source="created_at_gte"
				label={translate(
					"resources.moderation_activities.filters.created_after",
				)}
				alwaysOn
			/>

			<DateInput
				source="created_at_lte"
				label={translate(
					"resources.moderation_activities.filters.created_before",
				)}
				alwaysOn
			/>
		</Filter>
	);
};

export default ModerationActivitiesFilter;
